// import log from 'loglevel'
import analyticsAPI from '@/api/analytics'
import _ from 'underscore'

const handlePayload = (key, selectedFilters) => {
  let payload = {}
  payload.key = `${selectedFilters.dashboardId}_${key}`
  payload.filters = { ...selectedFilters.filters }
  _.each(payload.filters, (filter, key) => {
    if (!_.isArray(filter)) {
      let tmp = []
      if (_.isObject(filter)) {
        if (filter.value !== -1) {
          tmp.push(filter.value)
        }
      } else {
        tmp.push(filter)
      }
      payload.filters[key] = tmp
    } else {
      payload.filters[key] = _.values(filter)
    }
  })
  payload.filters.is_ef = []
  payload.filters.date_time = []
  payload.pagination = {}
  return payload
}

const state = {
  lastUpdateTime: {
    key: 'lastUpdateTime',
    data: '',
    loader: true
  }
}

// getters
const getters = {
  lastUpdateTime: state => state.lastUpdateTime
}

// mutations
const mutations = {
  SET_LAST_UPDATE_TIME (state, data) { state.lastUpdateTime.data = data },
  SET_LAST_UPDATE_TIME_LOADER (state, data) { state.lastUpdateTime.loader = data }
}

// actions
const actions = {
  fetchLastUpdateTime ({ commit, getters }, payload) {
    commit('SET_LAST_UPDATE_TIME_LOADER', true)
    const key = getters.lastUpdateTime.key
    let preparedPayload = handlePayload(key, payload)

    return analyticsAPI.fetchData(preparedPayload, '')
      .then(data => {
        commit('SET_LAST_UPDATE_TIME_LOADER', false)
        if (data.errorCode) {
          commit('SET_LAST_UPDATE_TIME', '')
          return Promise.reject(data)
        } else {
          commit('SET_LAST_UPDATE_TIME', data.result[0].LastUpdate)
          return Promise.resolve(data)
        }
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
